module.exports = __webpack_public_path__ + "img/6.b073c192.jpg";